import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../button/button.jsx';

import styles from './save-button.css';

const SaveButton = ({
    className,
    isShared,
    onClick
}) => (
    <Button
        className={classNames(
            className,
            styles.saveButton,
            {[styles.saveButtonIsShared]: isShared}
        )}
        onClick={onClick}
    >
        {isShared ? (
            <FormattedMessage
                defaultMessage="已上传"
                description="Label for shared project"
                id="gui.menuBar.isShared"
            />
        ) : (
            <FormattedMessage
                defaultMessage="上传"
                description="upload a project to your account"
                id="gui.menubar.upload"
            />
        )}
    </Button>
);

SaveButton.propTypes = {
    className: PropTypes.string,
    isShared: PropTypes.bool,
    onClick: PropTypes.func
};

SaveButton.defaultProps = {
    onClick: () => {
    }
};

export default SaveButton;
